import React from 'react';
import { useMediaQuery } from 'react-responsive';

import CookieBanner from '../components/cookieConsent';
import FilterModal from '../modal/filter/product.filter.modal';
import theme from '../themeStyled';
import { AppContent, AppSidebar, AppFooter, AppHeader } from './components';
import { LayoutProps } from './index';

const MainLayout = (props: LayoutProps) => {
	const isMobile = useMediaQuery({
		query: `(max-width: ${theme.breakpoints.md})`,
	});
	return (
		<>
			<AppSidebar />
			<AppHeader />
			<AppContent {...props} />
			<AppFooter isMobile={isMobile} />
			<>
				<FilterModal />
			</>
			<CookieBanner />
		</>
	);
};

export default MainLayout;
